"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHighcharts = _interopRequireDefault(require("react-highcharts"));

var _highchartsMore = _interopRequireDefault(require("highcharts/highcharts-more"));

var _chartDataPropTypes = require("../manipulate/chartDataPropTypes.js");

var _HighchartsAllowNegativeLog = _interopRequireDefault(require("./HighchartsAllowNegativeLog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

(0, _highchartsMore["default"])(_reactHighcharts["default"].Highcharts);
(0, _HighchartsAllowNegativeLog["default"])(_reactHighcharts["default"].Highcharts);

var BoxplotCanvas = function BoxplotCanvas(_ref) {
  var titleSuffix = _ref.titleSuffix,
      xAxisCategories = _ref.xAxisCategories,
      boxplotSeries = _ref.boxplotSeries,
      loosePointsSeries = _ref.loosePointsSeries,
      unit = _ref.unit,
      cutoff = _ref.config.cutoff;

  //see also: transcripts colors
  var color = _reactHighcharts["default"].Highcharts.getOptions().colors[0];

  var series = [];
  boxplotSeries.length && series.push({
    name: "Observations",
    data: boxplotSeries,
    color: color,
    tooltip: {
      headerFormat: "<em>Factor: {point.key}</em><br/>"
    }
  });
  loosePointsSeries.length && series.push({
    name: "Observations",
    color: color,
    type: "scatter",
    data: loosePointsSeries,
    tooltip: {
      headerFormat: "<em>Factor: {point.key}</em><br/>",
      pointFormat: "<span style=\"color:{point.color}\">\u25CF</span><b> {series.name} </b> <br/>Expression: {point.y}<br/>"
    }
  });
  var config = {
    chart: {
      type: "boxplot",
      inverted: true,
      zoomType: "y"
    },
    plotOptions: {
      boxplot: {
        turboThreshold: 0
      },
      column: {
        dataLabels: {
          crop: false
        }
      },
      series: {
        animation: false,
        states: {
          hover: {
            color: "#eeec38" //#edab12 color cell on mouse over

          },
          select: {
            color: "#eeec38"
          }
        }
      }
    },
    credits: {
      enabled: false
    },
    title: {
      text: "Gene expression \u2013 ".concat(titleSuffix)
    },
    legend: {
      enabled: false
    },
    xAxis: {
      tickLength: 5,
      tickColor: "rgb(192, 192, 192)",
      lineColor: "rgb(192, 192, 192)",
      categories: xAxisCategories,
      labels: {
        style: {
          fontSize: "9px"
        }
      }
    },
    yAxis: {
      type: "logarithmic",
      plotLines: cutoff > 0.1 ? [{
        value: cutoff,
        dashStyle: "Dash",
        color: "#333333",
        width: 1,
        label: {
          text: "Cutoff: ".concat(cutoff),
          align: "left",
          style: {
            color: "gray"
          }
        }
      }] : [],
      title: {
        text: "Expression" + (unit ? " (".concat(unit, ")") : "")
      },
      min: 0.1
    },
    series: series
  };
  return /*#__PURE__*/_react["default"].createElement(_reactHighcharts["default"], {
    config: config
  });
};

BoxplotCanvas.propTypes = _chartDataPropTypes.boxplotData;
var _default = BoxplotCanvas;
exports["default"] = _default;